<template>
  <div>
    <el-dialog :close-on-click-modal="false"
      title="修改密码"
      :visible.sync="passwDialogVisible"
      :before-close="passwHandleClose"
      width="24%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>

      <el-form
        :model="ruleForm"
        :rules="rule"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="120px"
      >
        <div class="passInput">
          <el-form-item class="fsw" label="设置新密码:" prop="pass">
          <el-input type="password" placeholder="请输入新密码"
          @keyup.native="keyUp"
          @keydown.native="keydown"
          v-model="ruleForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        </div>
        <div class="passInput">
          <el-form-item class="fsw" label="请再次输入密码:" prop="checkPass">
          <el-input
            type="password"
            placeholder="请输入新密码"
            v-model="ruleForm.checkPass"
            autocomplete="off"
            @keyup.native="keyUp"
            @keydown.native="keydown"
          ></el-input>
        </el-form-item>
        </div>
        <el-form-item class="autorBtn">
          <el-button class="btnCan" type="primary" @click="resetForm('ruleForm')">取消</el-button>
          <el-button class="btnSure" @click="submitForm('ruleForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { adminScenicPwdUpdatePost } from "@/request/scenics.js";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      passwDialogVisible: false,
      ruleForm: {
        pass: "",
        checkPass: ""
      },
      // 传参
      rulePar: {
        userid: "",
        password: "",
        confirm_password: "",
        token: ""
      },
      userId: "",
      Token: "",
      rule: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
  },
  methods: {
    passw(row) {
      console.log(row);
      this.userId = row.userid;
      this.passwDialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.rulePar = {
            userid: this.userId,
            password: this.ruleForm.pass,
            confirm_password: this.ruleForm.checkPass,
            token: this.Token
          };
          adminScenicPwdUpdatePost(this.rulePar).then(res => {
            console.log(res);
            if (res.data.rcode == 200) {
              this.$message.success(res.data.msg);
              this.passwDialogVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 弹框X
    passwHandleClose() {
      this.ruleForm = {
        pass: "",
        checkPass: ""
      };
      this.passwDialogVisible = false;
    },
     //限制输入特殊字符
     keyUp(e) {
           e.target.value = e.target.value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,"");
          },
           // 只能输入汉字、英文、数字
        keydown(e) {
           e.target.value = e.target.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g,"");
          }
  }
};
</script>

<style lang='less' scoped>
.demo-ruleForm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.el-form-item__label {
  position: relative;
}
.spanOne {
  position: absolute;
  top: 94px;
  left: 75px;
}
.spanTwo {
  position: absolute;
  top: 156px;
  left: 47px;
}
/deep/.el-input {
  // width: 240px;
  height: 40px;
}
.autorBtn {
  margin-top: 18px;
  margin-left: -120px;
  .btnCan {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    /* identical to box height */
    color: #ffffff;
    border: none;
  }
  .btnSure {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    /* identical to box height */
    color: #ffffff;
  }
}
/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/ .el-dialog{
  min-width: 300px;
}
/deep/ .el-dialog__title{
  color: #000 !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}
.passInput{
  display: flex;
}
</style>